import Vue from 'vue'

Vue.filter('lbsAuth', (value) => {
    let auth = ''
    switch (value) {
        case '1':
            auth = '책임자'
            break
        case '2':
            auth = '관리자'
            break
        case '9':
            auth = '취급자'
            break
        default:
            auth = '확인안됨'
            break
    }

    return auth
})